import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	doneTitle: {
		id: 'contextual-summary.project-summary.overview-count.done-title',
		defaultMessage: '<header>{count} completed</header> <copy>in the last 7 days</copy>',
		description: 'The title for the completed overview count',
	},
	updatedTitle: {
		id: 'contextual-summary.project-summary.overview-count.updated-title',
		defaultMessage: '<header>{count} updated</header> <copy>in the last 7 days</copy>',
		description: 'The title for the updated overview count',
	},
	createdTitle: {
		id: 'contextual-summary.project-summary.overview-count.created-title',
		defaultMessage: '<header>{count} created</header> <copy>in the last 7 days</copy>',
		description: 'The title for the created overview count',
	},
	dueTitle: {
		id: 'contextual-summary.project-summary.overview-count.due-title',
		defaultMessage: '<header>{count} due</header> <copy>in the next 7 days</copy>',
		description: 'The title for the due overview count',
	},
});
